import script from "./BatchEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchEdit.vue?vue&type=script&setup=true&lang=ts"

import "./BatchEdit.vue?vue&type=style&index=0&id=11de5ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11de5ada"]])

export default __exports__